var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnBnbWomen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    fill: "#fff",
    stroke: "#f5f5f5"
  }
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  stroke: "none",
  rx: 30,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 59,
  x: 0.5,
  y: 0.5,
  rx: 29.5,
  style: {
    fill: "none"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.499 41h1.963l2.47-8.671h-2.08L14.347 38.6l-1.638-6.271h-1.443L9.615 38.6l-1.521-6.266H6.027L8.51 41h1.963l1.508-5.954zm4.173-4.329a4.354 4.354 0 0 0 4.527 4.485 4.357 4.357 0 0 0 4.537-4.485 4.357 4.357 0 0 0-4.537-4.485 4.354 4.354 0 0 0-4.524 4.485zm7.163 0a2.64 2.64 0 0 1-2.636 2.847 2.63 2.63 0 0 1-2.626-2.847 2.62 2.62 0 0 1 2.626-2.847 2.63 2.63 0 0 1 2.639 2.847zM35.121 41h1.859v-8.671h-2.6l-2.106 5.408-2.106-5.408h-2.587V41h1.846v-6.24L31.871 41h.806l2.444-6.24zm3.12 0h6.136v-1.6h-4.29v-2.014h4.2V35.8h-4.2v-1.885h4.29v-1.586h-6.136zm13.1 0h1.781v-8.671H51.28v5.616l-4.017-5.616h-1.9V41h1.846v-5.824z",
  "data-name": "Path 484"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.829 20a4.03 4.03 0 0 0 4.152 4.156 4.26 4.26 0 0 0 3.228-1.416V19.8h-3.768v1.056h2.568V22.3a3.1 3.1 0 0 1-2.028.792A2.917 2.917 0 0 1 19.065 20a2.9 2.9 0 0 1 2.916-3.068 2.76 2.76 0 0 1 2.2 1.08l.968-.564a3.76 3.76 0 0 0-3.168-1.584A4.02 4.02 0 0 0 17.829 20m11.46 4.144a2.873 2.873 0 0 0 2.928-3.044 2.87 2.87 0 0 0-2.928-3.04 2.877 2.877 0 0 0-2.928 3.04 2.88 2.88 0 0 0 2.928 3.044m0-.96a1.89 1.89 0 0 1-1.8-2.084 1.884 1.884 0 0 1 1.8-2.08 1.877 1.877 0 0 1 1.8 2.08 1.88 1.88 0 0 1-1.8 2.084",
  "data-name": "Path 485"
})), /*#__PURE__*/React.createElement("path", {
  d: "m43.108 22.726 3.4 3.4-3.4 3.4",
  "data-name": "Path 397",
  style: {
    stroke: "#000",
    strokeLinejoin: "round",
    fill: "none"
  },
  transform: "translate(-6.108 -5.726)"
}));
export default SvgBtnBnbWomen;